import type { ShapePreset } from '../data/v1'

/**
 * Adding a shape is an entry here plus a `preset` enum member in `data/v1.ts` (and the
 * matching enum in `canvas-schema.json`). Paths are filled with fill-rule: evenodd.
 */
export const SHAPE_PRESETS: Record<ShapePreset, { label: string; viewBox: string; path: string }> = {
	locationPin: {
		label: 'Location pin',
		viewBox: '0 0 24 24',
		path: 'M12 23C12 23 4 14.5 4 9A8 8 0 0 1 20 9C20 14.5 12 23 12 23Z'
			+ 'M12 6A3 3 0 1 0 12 12A3 3 0 1 0 12 6Z',
	},
	heart: {
		label: 'Heart',
		// offset to visually centre the shape
		viewBox: '0 -0.5 14 14',
		path:
			'M4.0072 1.00954c0.98164 0.07252 2.00443 0.55774 2.985 1.53745 0.98151 -0.97685 2.0067 -1.45914 2.99059 -1.52979 1.11071 -0.079751 2.09191 0.37134 2.79981 1.08284 1.3925 1.39964 1.8168 3.92914 0.0604 5.66329l-0.0116 0.01109 -5.50013 5.09248c-0.19168 0.1775 -0.48769 0.1775 -0.67938 0L1.15173 7.77442c-0.00505 -0.00467 -0.00999 -0.00944 -0.01484 -0.01431 -1.730877 -1.74047 -1.308346 -4.26998 0.07841 -5.66965 0.70533 -0.7119 1.68331 -1.162818 2.7919 -1.08092Z',
	},
	badge: {
		label: 'Badge',
		viewBox: '0 0 48 48',
		path:
			'M26.6698 1.83126c-1.3979 -1.650013 -3.9429 -1.650013 -5.3408 0l-3.0763 3.63099c-0.1225 0.14455 -0.3161 0.20746 -0.5002 0.16251l-4.623 -1.12932c-2.1009 -0.51318 -4.15974 0.98268 -4.32086 3.13927l-0.35456 4.74579c-0.01411 0.1889 -0.13379 0.3536 -0.3091 0.4254l-4.40392 1.8037c-2.00125 0.8197 -2.787672 3.2401 -1.65041 5.0795l2.50264 4.0478c0.09963 0.1611 0.09963 0.3647 0 0.5259l-2.50264 4.0478C0.953388 30.15 1.73981 32.5703 3.74106 33.39l4.40392 1.8037c0.17531 0.0718 0.29499 0.2365 0.3091 0.4255l0.35456 4.7457c0.16112 2.1566 2.21996 3.6525 4.32086 3.1393l4.623 -1.1293c0.1841 -0.045 0.3777 0.0179 0.5002 0.1625l3.0763 3.631c1.3979 1.65 3.9429 1.65 5.3408 0l3.0764 -3.631c0.1224 -0.1446 0.3161 -0.2075 0.5001 -0.1625l4.623 1.1293c2.1009 0.5132 4.1597 -0.9827 4.3209 -3.1393l0.3545 -4.7457c0.0141 -0.189 0.1338 -0.3537 0.3091 -0.4255l4.4039 -1.8037c2.0013 -0.8197 2.7877 -3.24 1.6505 -5.0794l-2.5027 -4.0478c-0.0996 -0.1612 -0.0996 -0.3648 0 -0.5259l2.5027 -4.0478c1.1372 -1.8394 0.3508 -4.2598 -1.6505 -5.0795l-4.4039 -1.8037c-0.1753 -0.0718 -0.295 -0.2365 -0.3091 -0.4254l-0.3545 -4.74579c-0.1612 -2.15659 -2.22 -3.65246 -4.3209 -3.13927l-4.623 1.12932c-0.184 0.04495 -0.3777 -0.01796 -0.5001 -0.16251l-3.0764 -3.63099Z',
	},
}

export const SHAPE_PRESET_IDS = Object.keys(SHAPE_PRESETS) as ShapePreset[]

// Falls back for a preset path, which carries no paint of its own and would otherwise render
// browser-default black, and for a fill token whose branding colour is unset. Either way the
// shape takes the text colour it inherits.
export const SHAPE_DEFAULT_FILL = 'currentColor'
